import { html, style, script, types, values } from "@common/schema/content/fields";

export const schema = [
  {
    id: "/Page/Element/Type/Code",
    type: "object",
    // The same fields a Section carries, inlined. A `code` element is an
    // anonymous section: identical to render, invisible to every other page.
    properties: {
      html,
      style,
      script,
      types,
      values,
    },
    required: [],
  },
];
